module.exports = __webpack_public_path__ + "static/media/galerija_2019 (4).40178039.jpg";